import { render, staticRenderFns } from "./ShowQuestionModal.vue?vue&type=template&id=66402bcc&"
import script from "./ShowQuestionModal.vue?vue&type=script&lang=js&"
export * from "./ShowQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports